import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export default [{
  path: "/extension/capital_pool",
  name: "capital_pool",
  component: function component() {
    return import("../../../views/extension/capital_pool/index.vue");
  },
  meta: {
    foot: true
  }
}];